export const tag = (tagName, className = null, innerHTML = null) => {
    tagName = tagName.toUpperCase();
    const el = document.createElement(tagName);

    if (innerHTML) el.innerHTML = innerHTML;

    if (className) el.classList.add(className);

    return el;
};
